import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SettingModel } from 'src/app/core/models/classes/setting';
import { SettingsService } from 'src/app/core/services/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-mapsettings',
  templateUrl: './mapsettings.component.html',
  styleUrls: ['./mapsettings.component.scss']
})

export class MapsettingsComponent implements OnInit{
  wmsLink: string = '';
  mapCacheId: string = 'd79c26749188426381c70996c0bd18ca';
  mapCacheName: string = '';
  srid: number = 0;
  attributation: string = 'OpenStreetMap® contributors';
  domainname:string='';
  server: string = '';
  port: string = '';
  email: string = '';
  pass: string = '';
  ssl: boolean = false;
  appSettings: SettingModel[] = [];

  constructor(
    private settingService: SettingsService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<MapsettingsComponent>
  ) {}

  ngOnInit(): void {
    this.settingService.getSettings().subscribe({
      next: (s) => {
          this.mapCacheId = s.mapCacheId;
          this.wmsLink = s.wmsLink;
          this.mapCacheName = s.mapCacheName;
          this.srid = s.srid;
          this.domainname = s.domainName;
          this.attributation = s.mapAttributation;

          this.server = s.server;
          this.port = s.port;
          this.email = s.email;
          this.pass = s.password;
          this.ssl = s.ssl;
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  onSave(): void {
    var setting = new SettingModel();
    //Map settings
    setting.mapCacheId = this.mapCacheId;
    setting.mapCacheName = this.mapCacheName;
    setting.srid = this.srid;
    setting.wmsLink = this.wmsLink;
    setting.mapAttributation= this.attributation;

    //Email settings
    setting.server = this.server;
    setting.email = this.email;
    setting.password = this.pass;
    setting.port = this.port;
    setting.ssl = this.ssl;
    setting.domainName=this.domainname;

    this.settingService.addSettings(setting).subscribe({
      next: (data) => {
        if (data.status === 200) {
          this._snackBar.open($localize `Map settings saved successfully`, '', {
            duration: 3000
          });
          this.dialogRef.close();
        }
      },
    });
  }
}
